import React, { useState } from 'react'
import { Col, Row, Form, Badge } from 'react-bootstrap';
import styles from './emailDetails.module.scss';
import { Formik } from 'formik';
import * as yup from 'yup';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomButton } from '../../../../shared/customButton';
import { CustomTextEditor } from '../../../../shared/customTextEditor';

function EmailDetails(props) {

    let [email_body_html, setEmailBodyHtml] = useState(props.emailData.templateBody);

    const removeTextDecoration = (htmlContent) => {
        let noDecoration = htmlContent.replace(/<span style="text-decoration: (underline|line-through|overline);[^>]*>(.*?)<\/span>/gi, '$2');
        noDecoration = noDecoration.replace(/<span style="background-color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        noDecoration = noDecoration.replace(/<span style="color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        let withFont = noDecoration.replace(/(<span[^>]*>)(<\/span>)/gi, (match, opening, closing) => {
            if (opening) {
                return opening + ' style="font-family: Inter, sans-serif; font-size: 12px;"';
            } else {
                return closing;
            }
        });
        // Set font family and size to Inter, sans-serif; font-size: 16px for <h3> tags
        withFont = withFont.replace(/<h3[^>]*>(.*?)<\/h3>/gi, (match, content) => {
            return `<h3 style="font-family: Inter, sans-serif; font-size: 16px !important;">${content}</h3>`;
        });

        return withFont;
    };

    //yup validations
    const schema = yup.object({
        emailSubject: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required').nullable(),
        emailBody: yup.string().max(4000, 'Content is too lengthy').test('email body check', 'Required', function (item) {
            if (item) {
                let stripedHtml = item.replace(/<[^>]+>/g, '');
                if ((stripedHtml).length > 1) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }).nullable(),
    });

    return (
        <div>
            <Row className='ms-1 me-1'>
                <Col>
                    <p className={styles.stepSubtopicName}>Email Template Configurations</p>
                </Col>
            </Row>
            <hr className={styles.subTopicDivider} />
            <div className='mt-4 ms-1 me-1'>
                <Formik
                    validationSchema={schema}
                    enableReinitialize
                    onSubmit={(values) => props.onSubmitEmailData(values)}
                    initialValues={{ emailSubject: props.emailData.email_subject, emailBody: props.emailData.templateBody }}>

                    {({
                        values,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                        errors,
                        submitCount
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Label className={styles.defaultLabel}> To </Form.Label>
                            {(props.candidateEmail).length !== 0 &&

                                <Row  xs="auto" className='ms-1 me-1'>
                                    {
                                        (props.candidateEmail).map((item, i) => (
                                            (
                                                 <Col className='mt-1'>
                                                <div className={styles.emailbadgeDiv} key={i}>
                                                    <Badge bg="light" className={styles.emailbadge}>{item}&nbsp;&nbsp;

                                                    </Badge>
                                                </div>
                                                </Col>
                                            )
                                        ))
                                    }
                                </Row>
                            }

                            <CustomTextField
                                label="Email Subject"
                                classLabel="defaultLabel"
                                controlId="emailSubject"
                                type="text"
                                handleOnChange={handleChange}
                                name="emailSubject"
                                classType="defaultTextBox"
                                value={values.emailSubject}
                                errorMessage={errors.emailSubject}
                                isInvalid={submitCount > 0 && errors.emailSubject}
                            />
                            <Form.Group>
                                <Form.Label className={styles.defaultLabel}>
                                    Email Body Content
                                </Form.Label>


                                <div className='mb-3'>
                                    <div className={submitCount > 0 && errors.emailBody ? styles.emailBodyError : ''}>
                                        <CustomTextEditor
                                            value={email_body_html}
                                            handleOnChange={(e) => {
                                                setEmailBodyHtml(e);
                                                setFieldValue('emailBody', removeTextDecoration(e));
                                            }}
                                        />
                                    </div>
                                    {submitCount > 0 && errors.emailBody &&
                                        <p className={styles.errorLabel} >{errors.emailBody}</p>
                                    }
                                </div>
                            </Form.Group>

                            <Col>
                                <Row className={styles.actionBtns}>
                                    <Col className="pl-0">
                                        {<CustomButton
                                            buttonType="button"
                                            label="Cancel"
                                            type="defaultBtn"
                                            handleClick={() => props.closeModal()}

                                        />}
                                    </Col>
                                    <Col className="pr-0">
                                        {<CustomButton
                                            buttonType="submit"
                                            label="Next"
                                            type="primaryBtn"
                                        />}
                                    </Col>
                                </Row>
                            </Col>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default EmailDetails;
